import { createFileRoute } from '@tanstack/react-router'
import { AlreadyInstalled } from '@/components/installFlowV2/already-installed'
import { z } from 'zod'

export const Route = createFileRoute('/installFlow/already-installed')({
  component: AlreadyInstalled,
  validateSearch: z.object({
    redirect: z.string().optional().catch(""),
    installSensorKitSerialNumber: z.string().optional(),
  }),
})

